import { mountDialogUIReactComponent } from '../../ui_platform/mountDialogUIReactComponent.tsx';
import { ShareImageDialogContainer } from './ShareImageDialogContainer.tsx';
export const showShareImageDialog = mountDialogUIReactComponent(ShareImageDialogContainer);
